<template>
  <div
    id="compreSportsMeet_playerDetail"
    v-show="currThemeObj"
    :style="{
      '--mixtmt_scheduleDetail_banner': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/scheduleDetail_banner.png')`,
    }"
  >
    <div class="abs_top">
      <sportsDetail_inforPanel
        :currThemeObj="currThemeObj"
        :currSportsDetail="currSportsDetail"
        :playerBaseInfor="playerBaseInfor"
        @clickIsOpenMeunEvent="clickIsOpenMeunHandler"
      ></sportsDetail_inforPanel>
    </div>
    <NOT_DATA :className="'relativePtb60'" v-if="noData" />
    <div class="inforData" v-else>
      <div class="group" v-if="joinSportsArr && joinSportsArr.length > 0">
        <div class="match_label">
          <span class="label_textArea">
            <span v-text="'参加项目'"></span>
          </span>
        </div>
        <div
          class="group_data"
          v-for="item in joinSportsArr"
          :key="item.eventCode"
        >
          <span
            class="group_data_text"
            v-text="`${item.disciplineName}·${item.eventName}`"
          ></span>
        </div>
      </div>
      <div class="group" v-if="medalList && medalList.length > 0">
        <div class="match_label">
          <span class="label_textArea">
            <span v-text="'获奖明细'"></span>
          </span>
        </div>
        <div class="group_data" v-for="item in medalList" :key="item.eventCode">
          <span class="medalType" :class="item.medalType"></span>
          <span
            class="group_data_text"
            v-text="`${item.disciplineName}·${item.eventName}`"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sportsDetail_inforPanel from './playerDetail_inforPanel'
import cup_base_data_mixin from '@mixins/cup_base_data'
import NOT_DATA from '@components/base/NO_DATA.vue'
import { https_playerDetail } from '@api/platfrom_compreSportsMeet_api'
export default {
  name: 'compreSportsMeet_playerDetail',
  components: { sportsDetail_inforPanel, NOT_DATA },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      isRefresh: false, //是否需要实时更新
      refreshTime: 15 * 1000,
      currSportsDetail: {
        sportsId: null,
        sportsName: null,
        eventId: null,
        eventName: null,
        matchId: null,
      },
      playerBaseInfor: null,
      joinSportsArr: null,
      medalList: null,
    }
  },
  computed: {
    noData() {
      return (
        this.joinSportsArr &&
        this.joinSportsArr.length == 0 &&
        this.medalList &&
        this.medalList.length === 0
      )
    },
  },
  created() {
    console.debug('route:', this.$route)
    const query = this.$route.query
    this.init(query)
    // setTimeout(() => {
    //   let currSportsDetail = JSON.parse(JSON.stringify(this.currSportsDetail))
    //   currSportsDetail.sportsName = '足球'
    //   this.currSportsDetail = currSportsDetail
    // }, 10 * 1000)
  },
  methods: {
    async init(query) {
      console.debug(this.currCid, this.currSid)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getPlayerDetail(query)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickIsOpenMeunHandler(data) {
      console.debug('clickIsOpenMeunHandler:', data)
      this.containerCascaderMeun_isOpenFlag = data
    },
    async getPlayerDetail(query) {
      let params = {
        sid: this.currSid,
        playerId: query.playerId,
      }
      await https_playerDetail(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.joinSportsArr = res.data.eventInfo ? res.data.eventInfo : []
            this.medalList = res.data.medalInfo ? res.data.medalInfo : []

            // this.joinSportsArr = [
            //   {
            //     medalType: 'ME_GOLD',
            //     disciplineName: '田径',
            //     eventName: '测试',
            //     eventCode: '11',
            //   },
            // ]
            // this.medalList = [
            //   {
            //     medalType: 'ME_GOLD',
            //     disciplineName: '田径',
            //     eventName: '测试',
            //     eventCode: '11',
            //   },
            // ]
            this.playerBaseInfor = res.data.statInfo
              ? {
                  playerId: res.data.statInfo.athleteCode,
                  playerName: res.data.statInfo.athleteName,
                  playerLogo: res.data.statInfo.athleteLogo,
                  gender: res.data.statInfo.gender,
                  birthDate: res.data.statInfo.birthDate,
                  height: res.data.statInfo.height,
                  weight: res.data.statInfo.weight,
                  delegationId: res.data.statInfo.organisationCode,
                  delegationName: res.data.statInfo.organisationName,
                  delegationLogo: res.data.statInfo.organisationLogo,
                  medalTotal: res.data.statInfo.medalTotal,
                  medalGold: res.data.statInfo.medalGold,
                  medalSilver: res.data.statInfo.medalSilver,
                  medalBronze: res.data.statInfo.medalBronze,
                }
              : null
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_playerDetail {
  padding-top: 12.36vw;
  .abs_top {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 0 9.722vw;
    width: 100%;
    height: 12.36vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_scheduleDetail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
  }
  .inforData {
    width: 100%;
    padding: 6.26vw 0 4.16vw 0;
    .group {
      width: 100%;
      padding-bottom: 2.083vw;
      .match_label {
        position: relative;
        width: 100%;
        height: 3.472vw;
        background-image: var(--mixtmt_scheduleMatchList_dateBg);
        background-size: 100% auto;
        background-position: left top;
        background-repeat: no-repeat;

        .label_textArea {
          position: absolute;
          left: 0;
          top: 50%;
          z-index: 2;
          transform: translateY(-50%);
          width: 21.55%;
          font-size: 1.38vw;
          color: var(--mixtmt_whiteColor);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .labelIcon {
            width: 2.778vw;
            height: 2.778vw;
            border: 1.5px solid var(--mixtmt_whiteColor);
            border-radius: 50%;
            overflow: hidden;
            margin-right: 0.694vw;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          & .letterSpa {
            letter-spacing: 0.4vw;
          }
        }
      }
      .group_data {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 2.083vw;

        color: var(--mixtmt_greyColor3);
        .group_data_text {
          font-size: 1.38vw;
        }
        .medalType {
          width: 2.083vw;
          height: 2.083vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 1.0416vw;
          &.ME_GOLD {
            background-image: var(--mixtmt_medal_gold_icon);
          }
          &.ME_SILVER {
            background-image: var(--mixtmt_medal_silver_icon);
          }
          &.ME_BRONZE {
            background-image: var(--mixtmt_medal_bronze_icon);
          }
        }
      }
    }
  }
}
</style>
